import React from 'react';
import bem from 'utils/bem';
import FormikCheckboxField from 'forms/fields/CheckboxField/FormikCheckboxField';
import './index.sass';

const { block } = bem('moscow-time-checkbox-field');
const MoscowTimeCheckboxField = ({name, ...rest}) => {

    //todo: make conditional from workingOffline text
    const text = `Я ознакомлен, что время начала консультаций указано по Московскому времени`;

    return (
        <FormikCheckboxField className={ block() } name={name} text={ text } {...rest}/>
    );
};

export default MoscowTimeCheckboxField;
